const zh_ui = {
  'title'       : '龍輝護符查詢',
  'rarity'      : '稀有度',
  'ability'     : '效果',
  'condition'   : '觸發條件',
  'exclusive'   : '專屬條件',
  'availability': '取得方式',
  'name'        : '名稱',
  'search'      : '搜尋',
  'clear'       : '清除',
  'seasonal'    : '限定',
  'event'       : '活動',
  'collab'      : '合作',
  'promo'       : '特典'
}

export default zh_ui